export class Candidate {
    constructor() {
        this.id = null;
        this.name;
        this.firstName;
        this.lastName;
        this.workphone;
        this.mobilephone;
        this.email;
        this.im;
    }
}
//# sourceMappingURL=candidate.js.map